// Afterpay Custom Styling and Content Handler
(function () {
  "use strict";

  // CSS styles to inject
  const afterpayStyles = `
    /* Afterpay app block styling */
    square-placement .afterpay-paragraph,
    .shopify-app-block .afterpay-paragraph {
      border: 1px solid #e5e6e9 !important;
      border-radius: 24px !important;
      padding: 12px 16px !important;
      
      margin: 8px 0 !important;
      font-size: 14px !important;
      line-height: 1.4 !important;
      color: #333 !important;
    }

    /* HR styling between Afterpay and custom content */
    .afterpay-separator {
      margin: 16px 0;
      border: none;
      border-top: 1px solid #e0e0e0;
      opacity: 0.5;
    }

    /* Custom HR style options */
    .afterpay-separator.style-1 {
      border-top: 2px solid #007bff;
      opacity: 0.8;
      margin: 20px 0;
    }

    .afterpay-separator.style-2 {
      border-top: 1px dashed #dee2e6;
      opacity: 0.7;
      margin: 12px 0;
    }

    .afterpay-separator.style-3 {
      border-top: 3px solid #28a745;
      opacity: 0.6;
      margin: 24px 0;
      border-radius: 2px;
    }

    .afterpay-separator.style-4 {
      border: none;
      height: 1px;
      background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
      margin: 18px 0;
    }

    /* Additional div styling below Afterpay */
    .afterpay-additional-content {
      margin-top: 12px;
      padding: 16px;
      text-align: left;
      font-size: 12px;
      color: #666;
      border: 1px solid #e0e0e0;
      border-radius: 12px;
      background-color: #fafafa;
      width: 100%;
      box-sizing: border-box;
    }

    /* Custom styling options for afterpay-additional-content */
    .afterpay-additional-content.custom-style-1 {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      border: 2px solid #dee2e6;
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .afterpay-additional-content.custom-style-2 {
      background-color: #ffffff;
      border: 1px solid #007bff;
      border-radius: 8px;
      padding: 12px;
      color: #007bff;
      font-weight: 500;
    }

    .afterpay-additional-content.custom-style-3 {
      background-color: #f8f9fa;
      border: none;
      border-radius: 20px;
      padding: 24px;
      text-align: center;
      box-shadow: inset 0 1px 3px rgba(0,0,0,0.1);
    }

    /* Payment icons styling */
    .payment-icons {
      display: flex;
      justify-content: start;
      align-items: center;
      gap: 8px;
      margin-top: 8px;
      flex-wrap: wrap;
    }

    .payment-icon {
      height: 24px;
      width: auto;
      opacity: 0.7;
      transition: opacity 0.2s ease;
    }

    .payment-icon:hover {
      opacity: 1;
    }

    /* Style for Shopify payment icons */
    .afterpay-additional-content .payment-icons .icon {
      height: 20px !important;
      width: 32px !important;
      opacity: 0.7 !important;
      transition: opacity 0.2s ease !important;
      display: inline-block !important;
    }

    .afterpay-additional-content .payment-icons .icon:hover {
      opacity: 1 !important;
    }

    .afterpay-additional-content .payment-icons svg {
      height: 20px !important;
      width: 32px !important;
      display: block !important;
    }

    .afterpay-additional-content .payment-icons .payment-icon {
      height: 20px !important;
      width: 32px !important;
      opacity: 0.7 !important;
      transition: opacity 0.2s ease !important;
      display: inline-block !important;
    }

    .afterpay-additional-content .payment-icons .payment-icon:hover {
      opacity: 1 !important;
    }
  `;

  // Function to inject CSS styles
  function injectStyles() {
    if (document.getElementById("afterpay-custom-styles")) {
      return;
    }

    const styleElement = document.createElement("style");
    styleElement.id = "afterpay-custom-styles";
    styleElement.textContent = afterpayStyles;
    document.head.appendChild(styleElement);
  }

  // Function to apply direct styles to afterpay-additional-content
  function applyAdditionalContentStyles(container) {
    // Apply styles to afterpay-additional-content
    // container.style
  }

  // Function to apply direct styles to HR separator
  function applyHRStyles(hrElement) {
    hrElement.style.margin = "16px 0";
    hrElement.style.border = "none";
    hrElement.style.height = "1px";
    hrElement.style.backgroundColor = "#e5e6e9";
    // Extend beyond parent padding (16px on each side) and align with parent border
    hrElement.style.marginLeft = "-17px"; // -16px padding - 1px border
    hrElement.style.marginRight = "-17px"; // -16px padding - 1px border
    hrElement.style.width = "calc(100% + 34px)"; // +32px padding + 2px border
  }

  // Function to apply direct styles to payment icons
  function applyPaymentIconStyles(container) {
    // Apply styles to payment-icons container
    const paymentIconsContainer = container.querySelector(".payment-icons");

    if (paymentIconsContainer) {
      paymentIconsContainer.style.display = "flex";
      paymentIconsContainer.style.justifyContent = "start";
      paymentIconsContainer.style.alignItems = "center";
      paymentIconsContainer.style.gap = "8px";
      paymentIconsContainer.style.marginTop = "8px";
      paymentIconsContainer.style.flexWrap = "wrap";
    }

    // Apply styles to individual payment icons
    const paymentIcons = container.querySelectorAll(
      ".payment-icons .icon, .payment-icons .payment-icon"
    );
    paymentIcons.forEach((icon) => {
      icon.style.height = "20px";
      icon.style.width = "32px";
      icon.style.display = "inline-block";

      // Apply styles to SVG inside
      const svg = icon.querySelector("svg");
      if (svg) {
        svg.style.height = "20px";
        svg.style.width = "32px";
        svg.style.display = "block";
      }
    });
  }

  // Function to modify Afterpay text content
  function modifyAfterpayText() {
    // Try regular DOM first
    let mainTextElement = document.querySelector(".afterpay-main-text");

    // If not found, check Shadow DOM
    if (!mainTextElement) {
      const squarePlacement = document.querySelector("square-placement");
      if (squarePlacement && squarePlacement.shadowRoot) {
        mainTextElement = squarePlacement.shadowRoot.querySelector(
          ".afterpay-main-text"
        );
      }
    }

    if (mainTextElement) {
      // Extract the amount from existing text (e.g., "$312.50")
      const strongTag = mainTextElement.querySelector("strong");
      if (strongTag) {
        const amount = strongTag.textContent;
        // Replace with new text format
        mainTextElement.innerHTML = `4 payments of <strong>${amount}</strong> `;
      }
    }

    // Also handle regular DOM if it exists separately
    const regularMainText = document.querySelector(
      "p.afterpay-paragraph .afterpay-main-text"
    );
    if (regularMainText) {
      const strongTag = regularMainText.querySelector("strong");
      if (strongTag) {
        const amount = strongTag.textContent;
        regularMainText.innerHTML = `4 payments of <strong>${amount}</strong> `;
      }
    }
  }

  // Function to load payment icons from Shopify
  function loadPaymentIcons(container) {
    // Get payment icons from footer (same as shop.enabled_payment_types)
    const footerPaymentIcons = document.querySelector(
      ".footer__payment .list-payment"
    );

    if (footerPaymentIcons) {
      const paymentItems = footerPaymentIcons.querySelectorAll(
        ".list-payment__item"
      );
      const paymentIconsContainer = container.querySelector(".payment-icons");

      paymentItems.forEach((item, index) => {
        // Skip the first payment icon (index 0)
        if (index === 0) return;

        const iconElement = item.querySelector(".icon");
        if (iconElement) {
          // Clone the icon and add to our container
          const clonedIcon = iconElement.cloneNode(true);
          clonedIcon.classList.add("payment-icon");
          paymentIconsContainer.appendChild(clonedIcon);
        }
      });

      // Apply direct styles after cloning
      setTimeout(() => applyPaymentIconStyles(container), 100);
    } else {
      // Fallback: try to get payment icons from any existing payment list
      const anyPaymentList = document.querySelector(".list-payment");
      if (anyPaymentList) {
        const paymentItems = anyPaymentList.querySelectorAll(
          ".list-payment__item"
        );
        const paymentIconsContainer = container.querySelector(".payment-icons");

        paymentItems.forEach((item, index) => {
          // Skip the first payment icon (index 0)
          if (index === 0) return;

          const iconElement = item.querySelector(".icon");
          if (iconElement) {
            const clonedIcon = iconElement.cloneNode(true);
            clonedIcon.classList.add("payment-icon");
            paymentIconsContainer.appendChild(clonedIcon);
          }
        });

        // Apply direct styles after cloning
        setTimeout(() => applyPaymentIconStyles(container), 100);
      }
    }
  }

  // Function to add additional content below Afterpay
  function addAfterpayContent() {
    // First try to find p.afterpay-paragraph in regular DOM
    let afterpayParagraph = document.querySelector("p.afterpay-paragraph");

    // If not found, check Shadow DOM
    if (!afterpayParagraph) {
      const squarePlacement = document.querySelector("square-placement");
      if (squarePlacement && squarePlacement.shadowRoot) {
        afterpayParagraph = squarePlacement.shadowRoot.querySelector(
          "p.afterpay-paragraph"
        );
      }
    }

    if (afterpayParagraph) {
      // Check if afterpay-additional-content already exists in the parent
      const existingAdditionalContent =
        afterpayParagraph.parentNode.querySelector(
          ".afterpay-additional-content"
        );

      if (!existingAdditionalContent) {
        const additionalDiv = document.createElement("div");
        additionalDiv.className = "afterpay-additional-content";

        // Add your custom content here
        additionalDiv.innerHTML = `
          <div class="payment-icons">
            <!-- Payment icons will be dynamically loaded from Shopify -->
          </div>
        `;

        // Check if HR already exists, if not create one
        let hrElement = afterpayParagraph.parentNode.querySelector(
          ".afterpay-separator"
        );
        if (!hrElement) {
          hrElement = document.createElement("hr");
          hrElement.className = "afterpay-separator";

          // Apply custom styles to HR
          applyHRStyles(hrElement);

          // Insert HR first
          afterpayParagraph.parentNode.insertBefore(
            hrElement,
            afterpayParagraph.nextSibling
          );
        }

        // Apply styles to the container
        applyAdditionalContentStyles(additionalDiv);

        // Load payment icons from Shopify (same as footer)
        loadPaymentIcons(additionalDiv);

        // Insert custom div after HR
        afterpayParagraph.parentNode.insertBefore(
          additionalDiv,
          hrElement.nextSibling
        );
      }
    }
  }

  // Function to apply styles directly to square-placement
  function applyDirectStyles() {
    const squarePlacement = document.querySelector("square-placement");
    if (squarePlacement) {
      squarePlacement.style.border = "1px solid #e5e6e9";
      squarePlacement.style.borderRadius = "24px";
      squarePlacement.style.padding = "16px";
      squarePlacement.style.margin = "8px 0";
      squarePlacement.style.fontSize = "14px";
      squarePlacement.style.lineHeight = "1.4";
      squarePlacement.style.color = "#333";
      squarePlacement.style.borderBottom = "1px solid #e5e6e9";

      const pTags = squarePlacement.querySelectorAll("p");
      pTags.forEach((p) => {
        p.style.margin = "0";
        p.style.padding = "0";
      });

      return true;
    }
    return false;
  }

  // Function to wait for Afterpay to load from square-marketplace.js
  function waitForAfterpayLoad() {
    let attempts = 0;
    const maxAttempts = 40; // 20 seconds total

    const checkInterval = setInterval(() => {
      attempts++;

      const squarePlacement = document.querySelector("square-placement");
      if (squarePlacement && squarePlacement.shadowRoot) {
        const shadowPTags = squarePlacement.shadowRoot.querySelectorAll("p");

        if (shadowPTags.length > 0) {
          clearInterval(checkInterval);
          modifyAfterpayText();
          applyDirectStyles();
          addAfterpayContent();
        } else if (attempts >= maxAttempts) {
          clearInterval(checkInterval);
        }
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
      }
    }, 500);
  }

  // Function to handle Afterpay initialization
  function handleAfterpayInit() {
    injectStyles();
    modifyAfterpayText();
    addAfterpayContent();
    applyDirectStyles();
    waitForAfterpayLoad();
  }

  // Initialize when DOM is ready
  function init() {
    handleAfterpayInit();
    setTimeout(handleAfterpayInit, 1000);
    setTimeout(handleAfterpayInit, 3000);
    setTimeout(handleAfterpayInit, 5000);
  }

  // Start when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
